import logo from "../../../assets/images/logo.svg";
import logoLg from "../../../assets/images/logo-lg.svg";

const RenewalHeader = ({ sgThankYou = false }) => {
  return (
    <div className="flex justify-between container-lg bg-white shadow-2xl z-20">
      <div className="h-16 md:h-24 py-4 flex-shrink-0 mr-12">
        {/* Header for paynow renewal */}
        <picture onClick={() => (sgThankYou ? window.open("https://alliedworldinsurance.com/singapore/", "_blank") : window.location.reload())}>
          <source media="(min-width:768px)" srcSet={logoLg} />
          <img src={logo} alt="Allied World logo" className="h-full" />
        </picture>
      </div>
    </div>
  );
};
export default RenewalHeader;
